import { IProduct } from '@homeserve/od-typings/api';
import moment from 'moment';
import { ActionContext } from 'vuex';
import { getStoreAccessors } from 'vuex-typescript';
import { TimeSlot } from '../components/WLFixAppointment/interfaces';

type DiagnosticContext = ActionContext<DiagnosticState, any>;

export interface IPostCode {
  postCode: string;
  summary: string;
  town: string;
}
export interface DiagnosticState {
  comment?: string;
  domain: string;
  images: File[];
  postCode?: IPostCode;
  price: number;
  priceBreakDown: any[];
  product: IProduct | null;
  slot: TimeSlot;
  taxFreePrice: number;
}

moment.locale('fr');

const state: DiagnosticState = {
  postCode: {
    postCode: '',
    summary: '',
    town: '',
  },
  comment: '',
  slot: {},
  domain: '',
  product: null,
  price: 0,
  taxFreePrice: 0,
  priceBreakDown: [],
  images: [],
};

const getters = {
  postCode(s: DiagnosticState) {
    return s.postCode;
  },
  slot(s: DiagnosticState) {
    return s.slot;
  },
  comment(s: DiagnosticState) {
    return s.comment;
  },
  domain(s: DiagnosticState) {
    return s.domain;
  },
  product(s: DiagnosticState) {
    return s.product;
  },
  price(s: DiagnosticState) {
    return s.price;
  },
  priceBreakDown(s: DiagnosticState) {
    return s.priceBreakDown;
  },
  taxFreePrice(s: DiagnosticState) {
    return s.taxFreePrice;
  },

  images(s: DiagnosticState) {
    return s.images;
  },
};

const mutations = {
  postCode(s: DiagnosticState, postCode: IPostCode) {
    s.postCode = postCode;
  },
  slot(s: DiagnosticState, slot: TimeSlot) {
    s.slot = slot;
  },
  comment(s: DiagnosticState, comment: string) {
    s.comment = comment;
  },
  domain(s: DiagnosticState, domain: string) {
    s.domain = domain;
  },
  product(s: DiagnosticState, product: IProduct) {
    s.product = product;
  },
  price(s: DiagnosticState, price: number) {
    s.price = price;
  },
  priceBreakDown(s: DiagnosticState, priceBreakDown: any) {
    s.priceBreakDown = priceBreakDown;
  },
  taxFreePrice(s: DiagnosticState, price: number) {
    s.taxFreePrice = price;
  },
  images(s: DiagnosticState, images: File[]) {
    s.images = images;
  },
};

const actions = {
  setPostCode(context: DiagnosticContext, postCode: IPostCode) {
    context.commit('postCode', postCode);
  },
  setComment(context: DiagnosticContext, comment: string) {
    context.commit('comment', comment);
  },
  setSlot(context: DiagnosticContext, slot: TimeSlot) {
    context.commit('slot', slot);
  },
  setDomain(context: DiagnosticContext, domain: string) {
    context.commit('domain', domain);
  },
  setProduct(context: DiagnosticContext, product: IProduct | null) {
    context.commit('product', product);
  },
  setPrice(context: DiagnosticContext, price: number) {
    context.commit('price', price);
  },
  setPriceBreakDown(context: DiagnosticContext, priceBreakDown: Array<{ name: string; price: number }>) {
    context.commit('priceBreakDown', priceBreakDown);
  },
  setTaxFreePrice(context: DiagnosticContext, price: number) {
    context.commit('taxFreePrice', price);
  },
  setImages(context: DiagnosticContext, images: File[]) {
    context.commit('images', images);
  },
};
export const diagnostic = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
const { read, dispatch } = getStoreAccessors<DiagnosticState, any>('app/diagnostic');

const setPostCode = dispatch(diagnostic.actions.setPostCode);
const setDomain = dispatch(diagnostic.actions.setDomain);
const setComment = dispatch(diagnostic.actions.setComment);
const setSlot = dispatch(diagnostic.actions.setSlot);
const setProduct = dispatch(diagnostic.actions.setProduct);
const setPrice = dispatch(diagnostic.actions.setPrice);
const setPriceBreakDown = dispatch(diagnostic.actions.setPriceBreakDown);
const setTaxFreePrice = dispatch(diagnostic.actions.setTaxFreePrice);
const setImages = dispatch(diagnostic.actions.setImages);

const getDomain = read(diagnostic.getters.domain);
const getPostCode = read(getters.postCode);
const getProduct = read(getters.product);
const getSlot = read(getters.slot);

export const diagnosticHelper = {
  setPostCode,
  setComment,
  setSlot,
  setDomain,
  setProduct,
  setPrice,
  setPriceBreakDown,
  setTaxFreePrice,
  setImages,
  getDomain,
  getPostCode,
  getProduct,
  getSlot,
};
